/**
 * DataGrid / tablo layout yardımcıları
 */

export const getDataGridColumnsMinWidth = (columns, fallback = 140) =>
  (Array.isArray(columns) ? columns : []).reduce((sum, col) => {
    if (!col) return sum;
    const n = Number(col.minWidth ?? col.width);
    return sum + (Number.isFinite(n) && n > 0 ? n : fallback);
  }, 0);

const ACTION_FIELD_HINTS = /^(actions?|operation|operations|resetPassword|edit|delete)$/i;

export const isDataGridActionColumn = (column) => {
  if (!column) return false;
  if (column.type === "actions") return true;
  if (column.mobileRole === "actions") return true;
  return ACTION_FIELD_HINTS.test(String(column.field || ""));
};

/**
 * - Aksiyon kolonları: sabit width (butonlar ezilmesin)
 * - Diğer kolonlar: minWidth + flex → geniş ekranda alanı doldurur
 * - Toplam minWidth dar ekranda yatay scroll eşiğidir
 */
export const prepareDataGridColumnsForLayout = (columns) => {
  if (!Array.isArray(columns)) return [];
  return columns.map((col) => {
    if (!col) return col;
    const isAction = isDataGridActionColumn(col);
    const fallback = isAction ? 280 : 140;
    const minWidth = Math.max(
      Number(col.minWidth) || 0,
      Number(col.width) || 0,
      fallback
    );

    if (isAction) {
      return {
        ...col,
        flex: undefined,
        width: minWidth,
        minWidth,
        maxWidth: minWidth,
        resizable: false,
      };
    }

    const flex =
      typeof col.flex === "number" && col.flex > 0
        ? col.flex
        : 1;

    return {
      ...col,
      flex,
      minWidth,
      width: undefined,
      maxWidth: undefined,
      resizable: false,
    };
  });
};
